/**
 * Ant Design themed as SimFab.
 *
 * One mapping from the app's tokens (src/ui/palette.ts, the same values the
 * canvas painters and the styles.css custom properties use) onto antd's
 * design tokens, so an antd Modal and a bespoke panel sit on the same
 * surfaces with the same inks. Change a colour in APP_TOKENS and every
 * consumer - canvas, CSS var, antd - moves together.
 */

import { theme, type ThemeConfig } from 'antd'
import { APP_TOKENS } from '../../ui/palette'

export const antdTheme: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorBgBase: APP_TOKENS.surface,
    colorBgContainer: APP_TOKENS.surface,
    colorBgElevated: APP_TOKENS.surfaceRaised,
    colorBgLayout: APP_TOKENS.surfaceSunken,
    colorTextBase: APP_TOKENS.ink,
    colorTextSecondary: APP_TOKENS.ink2,
    colorTextTertiary: APP_TOKENS.inkMuted,
    colorBorder: APP_TOKENS.hairStrong,
    colorBorderSecondary: APP_TOKENS.hair,
    colorSplit: APP_TOKENS.hair,
    colorPrimary: APP_TOKENS.accent,
    colorInfo: APP_TOKENS.accent,
    colorLink: APP_TOKENS.accent,
    colorSuccess: APP_TOKENS.good,
    colorWarning: APP_TOKENS.warning,
    colorError: APP_TOKENS.critical,
    fontFamily: APP_TOKENS.font,
    // The bespoke chrome runs small radii and 13-14px text; antd's defaults
    // (8px, 14px) read close but the radius stands out on buttons.
    borderRadius: 6,
  },
  components: {
    Modal: {
      // Match the existing .modal-scrim's darkness so the two scrim worlds
      // are indistinguishable while both exist.
      colorBgMask: 'rgba(5, 8, 12, 0.62)',
    },
  },
}
